import { keysToCamelCaseDeep } from '@frontend/utils';

import { FetchError } from '../../fetchError';
import type { ResponsePayload } from '../../types';
import { ResponseOptions } from '../types';
import { getErrorMessage } from './getErrorMessage';

export const getPayload = async <T extends ResponsePayload>(
  response: Response,
  responseOptions: ResponseOptions = {
    shouldConvertResponseKeysToCamelCase: true,
  },
): Promise<T> => {
  const contentType = response.headers.get('Content-Type');
  const isImage = contentType?.includes('image');
  const isJSON = contentType?.includes('application/json');
  const isZip = contentType?.includes('application/zip');
  const isExcel = contentType?.includes(
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  );

  if (isImage || isZip || isExcel) {
    return response.blob() as Promise<T>;
  }
  if (isJSON) {
    try {
      if (responseOptions.shouldConvertResponseKeysToCamelCase) {
        return keysToCamelCaseDeep(await response.json()) as T;
      }
      return (await response.json()) as T;
    } catch (e) {
      throw new FetchError(response.status, getErrorMessage(e));
    }
  }
  return response.text() as Promise<T>;
};
